import { QueryKeys } from "@lib/enums/QueryKeys";
import type { QueryClient } from "@tanstack/react-query";

const QUERIES_TO_REMOVE = [
    QueryKeys.getProfile,
    QueryKeys.getAddresses,
    QueryKeys.getOrderHistoryDocument,
];

export const invalidateProfileQueries = (queryClient: QueryClient) => {
    // Completely delete the query cache so we don't keep a stale version of user data.
    QUERIES_TO_REMOVE.forEach((queryKey) => {
        queryClient.removeQueries({
            queryKey: [queryKey],
            exact: false,
        });
    });
};
